var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsAlertsFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M394.54,348.34,302.66,189.2,223.36,51.85a27,27,0,0,0-46.72,0L97.34,189.2,5.46,348.34A12.44,12.44,0,0,0,16.24,367H383.76A12.44,12.44,0,0,0,394.54,348.34ZM200,319a16,16,0,1,1,16-16A16,16,0,0,1,200,319Zm17-82a16,16,0,0,1-32,0V157a16,16,0,0,1,32,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAlertsFill);
export default __webpack_public_path__ + "static/media/Icons_Alerts Fill.3cdb5a871206adbe9e8bf410c08c593d.svg";
export { ForwardRef as ReactComponent };